
import React, { useState,useEffect} from "react";

const documents = [
  {
    id: 1,
    category: "GuideLine Report",
    title: "Career Club Operational Guideline",
    description:
      "This document provides a comprehensive framework for establishing, managing, and sustaining Career Clubs across institutions, ensuring alignment with Dereja’s youth employment objectives.",
    image: "/assets/careerclub.png",
    link: "/PDF/PolicyGuideline/CareerClub_operational_Guideline.pdf",
  },
  {
    id: 2,
    category: "GuideLine Report",
    title: "Dereja Alumni Network Guideline",
    description:
      "A strategic guide outlining the structure, operations, and engagement strategies for the Dereja Alumni Network to foster long-term professional development and community support.",
    image: "/assets/company.jpg",
    link: "/PDF/PolicyGuideline/Dereja_Almuni_Network_Operational_Guideline.docx.pdf",
  },
  {
    id: 3,
    category: "GuideLine Report",
    title: "Career Development Center (CDC) Standardization Manual",
    description:
      "This manual offers standardized procedures, service models, and quality benchmarks for Career Development Centers to deliver consistent and impactful career services.",
    image: "/assets/careerguide.jpg",
    link: "/PDF/PolicyGuideline/Final_CDC_Standidization_Manual.pdf",
  },
  {
    id: 4,
    category: "GuideLine Report",
    title: "Dereja Entrepreneurs Pitch Event Guide Manual",
    description:
      "This guide supports planning and delivering impactful pitch events for young entrepreneurs, providing templates, evaluation criteria, and facilitation tips.",
    image: "/assets/E1.jpg",
    link: "/PDF/PolicyGuideline/Dereja_Entrepreneurs_Pitch_Event_Guide.pdf",
  },
  {
    id: 5,
    category: "Mentorship Program Guideline",
    title: "Dereja Mentorship Program Guideline",
    description:
      "Outlines the framework, roles, and tools for facilitating effective mentorship relationships between experienced professionals and young job seekers.",
    image: "/assets/mentorship.jpg",
    link: "/PDF/PolicyGuideline/Dereja_Mentorship_Program_Guideline.pdf",
  },
  {
    id: 6,
    category: "Youth Advisory Group Guideline",
    title: "Dereja Youth Advisory Group Guideline",
    description:
      "Provides a structure for engaging youth voices in decision-making and program improvement through structured advisory groups.",
    image: "/assets/YAG.jpg",
    link: "/PDF/PolicyGuideline/Dereja_Youth_Advisory_Group_Guideline.pdf",
  },
];


export default function Policystrategy() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const itemsPerPage = 6;

  
  const filteredDocs = documents.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredDocs.length / itemsPerPage);
  const startIndex = page * itemsPerPage;
  const paginatedDocs = filteredDocs.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 0) setPage(page - 1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); 
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-orange mb-6 text-center">
        Knowledge Management Library
      </h1>

      <div className="max-w-2xl mx-auto mb-8">
        <input
          type="text"
          placeholder="Search documents..."
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
          onChange={handleSearch}
          value={searchTerm}
        />
        <p className="text-sm text-gray-600 mt-2">
          {filteredDocs.length > 0
            ? `Showing ${startIndex + 1}-${Math.min(
                startIndex + paginatedDocs.length,
                filteredDocs.length
              )} of ${filteredDocs.length} documents`
            : `No results found for "${searchTerm}"`}
        </p>
      </div>

      {filteredDocs.length > 0 ? (
        <>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
            {paginatedDocs.map((doc) => (
              <div
                key={doc.id}
                className="bg-white rounded-xl shadow hover:shadow-md p-4"
              >
                <img
                  src={doc.image}
                  alt={doc.title}
                  className="h-40 w-full object-cover rounded-md mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-800">
                  {doc.title}
                </h3>
                <p className="text-sm text-gray-600">{doc.description}</p>
                <a
                  href={doc.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block text-orange-600 hover:underline text-sm"
                >
                  View Document
                </a>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4">
            <button
              onClick={handlePrev}
              disabled={page === 0}
              className={`px-4 py-2 rounded-md font-semibold ${
                page === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Previous
            </button>
            <button
              onClick={handleNext}
              disabled={page >= totalPages - 1}
              className={`px-4 py-2 rounded-md font-semibold ${
                page >= totalPages - 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <div className="text-center text-gray-500 text-lg mt-20">
          📄 No documents match your search.
        </div>
      )}
    </div>
  );
}
